import React, { useEffect } from 'react'

// @see https://usehooks.com/useOnClickOutside/
export default (ref: React.RefObject<any>, callback: EventListener) => {
  useEffect(() => {
    const listener = (evt: MouseEvent | TouchEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (evt.defaultPrevented || !ref.current || ref.current.contains(evt.target as Node)) {
        return
      }
      callback(evt)
    }

    document.addEventListener('mousedown', listener, false)
    document.addEventListener('touchstart', listener, false)

    return () => {
      document.removeEventListener('mousedown', listener, false)
      document.removeEventListener('touchstart', listener, false)
    }

    // It's worth noting that because passed in callback
    // is a new function on every render that will cause this effect
    // callback/cleanup to run on every render.
    // To optimize you can wrap callback in useCallback before
    // passing it into this hook.
  }, [ref, callback])

  return ref
}
